"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Auth = _interopRequireDefault(require("ComposeUI/lib/Auth"));

var _BodyEditorContainer = _interopRequireDefault(require("composer-lib/containers/composer/BodyEditorContainer"));

var _constants = require("composer-lib/lib/constants");

var _ComposerToolbarGroup = _interopRequireDefault(require("composer-lib/components/composer/ComposerToolbarGroup"));

var _configureComposer = _interopRequireDefault(require("composer-lib/containers/configureComposer"));

var _reactRedux = require("react-redux");

var _ContentGroups = _interopRequireDefault(require("ComposeUI/data/model/ContentGroups"));

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _modals = require("ComposeUI/redux/actions/modals");

var _EditorsGroup = _interopRequireDefault(require("composer-lib/components/composer/EditorsGroup"));

var _FavoriteBlog = _interopRequireDefault(require("ComposeUI/data/model/FavoriteBlog"));

var _contentGroups = require("ComposeUI/redux/actions/contentGroups");

var _actions = require("ComposeUI/redux/actions");

var _userSettings = require("ComposeUI/redux/actions/userSettings");

var _utils = require("ComposeUI/lib/utils");

var _HeaderContainer = _interopRequireDefault(require("ComposeUI/containers/HeaderContainer"));

var _I18n = _interopRequireDefault(require("I18n"));

var _Modals = _interopRequireDefault(require("ComposeUI/data/model/Modals"));

var _ModalsContainer = _interopRequireDefault(require("ComposeUI/containers/ModalsContainer"));

var _PresenceContainer = _interopRequireDefault(require("composer-lib/containers/presence/PresenceContainer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ReadOnlyContainer = _interopRequireDefault(require("ComposeUI/containers/ReadOnlyContainer"));

var _post = require("ComposeUI/redux/actions/post");

var _TitleEditorContainer = _interopRequireDefault(require("composer-lib/containers/composer/TitleEditorContainer"));

var _ShareButtonContainer = _interopRequireDefault(require("composer-lib/containers/composer/ShareButtonContainer"));

var _ToolbarRowContainer = _interopRequireDefault(require("ComposeUI/containers/ToolbarRowContainer"));

var _UIFloatingAlertList = _interopRequireDefault(require("UIComponents/alert/UIFloatingAlertList"));

var _usageTracker = require("ComposeUI/lib/usageTracker");

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var _WordCountContainer = _interopRequireDefault(require("composer-lib/containers/composer/WordCountContainer"));

var _FileAccess = require("FileManagerLib/enums/FileAccess");

var _reactRhumb = require("react-rhumb");

var mapStateToProps = function mapStateToProps(state) {
  return {
    contentGroups: state.contentGroups,
    favoriteBlog: state.favoriteBlog,
    modals: state.modals,
    post: state.post,
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = {
  dismissModal: _modals.dismissModal,
  fetchContentGroups: _contentGroups.fetchContentGroups,
  fetchFavoriteBlog: _actions.fetchFavoriteBlog,
  fetchUserSettings: _userSettings.fetchUserSettings,
  openComposeEditInterstitialModal: _modals.openComposeEditInterstitialModal,
  openOnboardingModal: _modals.openOnboardingModal,
  savePost: _post.savePost
};

var Application = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Application, _Component);

  function Application(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Application);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Application).call(this, props));

    _this.handleGetBackUrl = function (composition) {
      var _this$props = _this.props,
          contentGroups = _this$props.contentGroups,
          favoriteBlog = _this$props.favoriteBlog;
      return (0, _utils.getBestBlogDashboardUrl)(contentGroups, favoriteBlog, composition);
    };

    _usageTracker.usageTracker.track('pageView', {
      screen: 'draft'
    });

    var _auth$get = _Auth.default.get(),
        user = _auth$get.user,
        gates = _auth$get.gates,
        portal = _auth$get.portal;

    _this.session = new Date().valueOf();
    _this.authData = {
      user: user,
      gates: gates,
      portal: portal,
      session: _this.session
    };

    _Routes.default.init(gates.toJS());

    var composerFeatures = [_constants.ComposerFeatures.CHANGE, _constants.ComposerFeatures.CLIP, _constants.ComposerFeatures.CONVERSATIONS, _constants.ComposerFeatures.GOOGLE_DOCS, _constants.ComposerFeatures.IMAGE, _constants.ComposerFeatures.LINK, _constants.ComposerFeatures.PRESENCE, _constants.ComposerFeatures.REVISIONS];

    if (user.get('scopes').includes('marketing-video')) {
      composerFeatures.push(_constants.ComposerFeatures.VIDEO);
    }

    var betas = [];

    if (gates.includes('composer_lib_toolbar_beta')) {
      betas.push(_constants.Betas.TOOLBAR);
    }

    _this.Composer = (0, _configureComposer.default)({
      betas: betas,
      composerFeatures: composerFeatures,
      fileManagerUploadedFileAccess: _FileAccess.DrawerFileAccess.VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE,
      fullScreen: true,
      usageTracker: _usageTracker.usageTracker
    });
    var userId = user.get('user_id');

    _this.props.fetchUserSettings(userId);

    _this.props.fetchFavoriteBlog(userId);

    _this.props.fetchContentGroups();

    _this.userId = userId;
    return _this;
  }

  (0, _createClass2.default)(Application, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPageTitle();
    }
  }, {
    key: "setPageTitle",
    value: function setPageTitle() {
      _I18n.default.title('ComposeUI.global.htmlTitle');
    }
  }, {
    key: "renderToolbarRow",
    value: function renderToolbarRow() {
      return _react.default.createElement(_ComposerToolbarGroup.default, {
        className: "toolbar-row-container",
        left: _react.default.createElement(_PresenceContainer.default, null),
        right: [_react.default.createElement(_WordCountContainer.default, {
          key: "word-count",
          useLineHeight: true
        }), _react.default.createElement(_ShareButtonContainer.default, {
          className: "m-left-2",
          key: "share-button"
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          contentGroups = _this$props2.contentGroups,
          favoriteBlog = _this$props2.favoriteBlog,
          modals = _this$props2.modals,
          params = _this$props2.params,
          userSettings = _this$props2.userSettings;
      return _react.default.createElement("div", null, _react.default.createElement(_reactRhumb.NavMarker, {
        name: "COMPOSER_LOADED"
      }), _react.default.createElement(this.Composer, {
        auth: this.authData,
        backLink: this.handleGetBackUrl,
        compositionId: parseInt(params.contentId, 10)
      }, _react.default.createElement(_HeaderContainer.default, {
        getBackLink: this.handleGetBackUrl,
        openComposeEditInterstitialModal: this.props.openComposeEditInterstitialModal,
        userId: this.userId,
        userSettings: userSettings
      }), _react.default.createElement(_ToolbarRowContainer.default, null), _react.default.createElement(_ReadOnlyContainer.default, {
        userSettings: userSettings
      }), _react.default.createElement(_EditorsGroup.default, null, _react.default.createElement(_TitleEditorContainer.default, {
        className: "m-bottom-7",
        tabIndex: "1"
      }), _react.default.createElement(_BodyEditorContainer.default, {
        tabIndex: "2"
      })), _react.default.createElement(_ModalsContainer.default, {
        contentGroups: contentGroups,
        dismissModal: this.props.dismissModal,
        favoriteBlog: favoriteBlog,
        modals: modals,
        openOnboardingModal: this.props.openOnboardingModal,
        savePost: this.props.savePost,
        userSettings: userSettings
      })), _react.default.createElement(_UIFloatingAlertList.default, null));
    }
  }]);
  return Application;
}(_react.Component);

Application.propTypes = {
  contentGroups: _propTypes.default.instanceOf(_ContentGroups.default),
  dismissModal: _propTypes.default.func.isRequired,
  favoriteBlog: _propTypes.default.instanceOf(_FavoriteBlog.default),
  fetchContentGroups: _propTypes.default.func.isRequired,
  fetchFavoriteBlog: _propTypes.default.func.isRequired,
  fetchUserSettings: _propTypes.default.func.isRequired,
  modals: _propTypes.default.instanceOf(_Modals.default).isRequired,
  openComposeEditInterstitialModal: _propTypes.default.func.isRequired,
  openOnboardingModal: _propTypes.default.func.isRequired,
  params: _propTypes.default.object,
  savePost: _propTypes.default.func.isRequired,
  userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
};
var reduxConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Application);
var _default = reduxConnect;
exports.default = _default;
module.exports = exports.default;